
import Wrapper from '@/components/MdxViewer';
import { makeServerSideProps } from '@/components/MdxViewer/serverSide';
import { Container } from '@mui/material';

import Content from './content.mdx';

export default () => (
    <Container maxWidth="lg" sx={{
        py: 10,
    }}>
        <Wrapper
            filePath='src/views/services/cloud/content.mdx'
            Component={Content}
        />
    </Container>
);

export const getServerSideProps = makeServerSideProps({
    app: {
        name: 'unrealos',
    },
    settings: {
        title: 'SaaS & PaaS Development: Scalable Cloud Solutions for Your Business',
        description: 'Build custom SaaS and PaaS platforms with scalable architecture, AI-driven features, and seamless integrations. Partner with Unrealos for innovative cloud solutions.',
    }
});